/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StealerLeak } from './StealerLeak';
import {
    StealerLeakFromJSON,
    StealerLeakFromJSONTyped,
    StealerLeakToJSON,
    StealerLeakToJSONTyped,
} from './StealerLeak';

/**
 * 
 * @export
 * @interface PaginatedStealerLeakList
 */
export interface PaginatedStealerLeakList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedStealerLeakList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedStealerLeakList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedStealerLeakList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<StealerLeak>}
     * @memberof PaginatedStealerLeakList
     */
    results: Array<StealerLeak>;
}

/**
 * Check if a given object implements the PaginatedStealerLeakList interface.
 */
export function instanceOfPaginatedStealerLeakList(value: object): value is PaginatedStealerLeakList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedStealerLeakListFromJSON(json: any): PaginatedStealerLeakList {
    return PaginatedStealerLeakListFromJSONTyped(json, false);
}

export function PaginatedStealerLeakListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedStealerLeakList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(StealerLeakFromJSON)),
    };
}

  export function PaginatedStealerLeakListToJSON(json: any): PaginatedStealerLeakList {
      return PaginatedStealerLeakListToJSONTyped(json, false);
  }

  export function PaginatedStealerLeakListToJSONTyped(value?: PaginatedStealerLeakList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(StealerLeakToJSON)),
    };
}

